import { Link } from 'react-router-dom'
import { publicDocsUrl, publicOpenApiUrl } from '../lib/developerApi'

export default function ApiDocsPage() {
  const base = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000'

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4">
          <span className="font-semibold">DIZEE API documentation</span>
          <div className="flex gap-4 text-sm">
            <Link to="/developers" className="text-indigo-600 hover:text-indigo-800">
              Developer portal
            </Link>
            <Link to="/home" className="text-gray-600 hover:text-gray-900">
              Home
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10">
        <h1 className="text-2xl font-semibold">Getting started</h1>
        <p className="mt-2 text-gray-600">
          Authenticate with header <code className="rounded bg-gray-100 px-1 text-sm">X-API-Key: dk_live_…</code> or{' '}
          <code className="rounded bg-gray-100 px-1 text-sm">Authorization: Bearer dk_live_…</code>
        </p>

        <p className="mt-4 text-sm text-gray-600">
          Base URL: <code className="rounded bg-gray-100 px-1">{base}/public/v1</code>
        </p>

        <ul className="mt-8 list-inside list-disc space-y-2 text-sm text-gray-700">
          <li>
            <a className="text-indigo-600 hover:underline" href={publicDocsUrl()} target="_blank" rel="noreferrer">
              Interactive Swagger UI
            </a>
          </li>
          <li>
            <a className="text-indigo-600 hover:underline" href={publicOpenApiUrl()} target="_blank" rel="noreferrer">
              OpenAPI JSON
            </a>
          </li>
        </ul>

        <h2 className="mt-10 text-lg font-semibold">Example</h2>
        <pre className="mt-2 overflow-x-auto rounded-lg bg-gray-900 p-4 text-xs text-gray-100">
          {`curl -H "X-API-Key: dk_live_your_key_here" \\
  "${base}/public/v1/me"`}
        </pre>
      </main>
    </div>
  )
}
